import * as React from "react";
import { observable, action } from "mobx";
import { IResult } from "../../../../../model/ModelTypes";
import { TextField, Button, DialogContainer } from "react-md";
import { observer } from "mobx-react";
import { isNullOrUndefined } from "util";
import * as moment from 'moment';

export class ViewResultDialogModel {
    @observable showDialog: boolean = false;
    @observable result: IResult;
    @observable onClose: Function;
    @action.bound
    setShowDialog(flag: boolean) {
        this.showDialog = flag;
    }
    @action.bound
    setResult(result: IResult) {
        this.result = result;
    }
    @action.bound
    close() {
        this.onClose();
    }
    constructor(onClose: Function) {
        this.onClose = onClose;
    }
} 
@observer class ViewResultDialog extends React.Component<{model: ViewResultDialogModel}, {}> {
    render() {
        let resultDateString = "";
        if (!isNullOrUndefined(this.props.model.result)) {
            let date = moment(this.props.model.result.submit_time).toDate();
            resultDateString = `${date.toDateString()} ${date.toLocaleTimeString()}`;
        }
        return(
            <div>
            {
                !isNullOrUndefined(this.props.model.result) &&
                <DialogContainer
                    id="delete-results-dialog"
                    visible={this.props.model.showDialog}
                    onHide={this.props.model.onClose}
                    actions={[
                    <Button
                        key="close"
                        flat={true}
                        secondary={true}
                        onClick={this.props.model.close}
                    >
                        Close
                    </Button>
                    ]}
                    title="User Result"
                >
                {
                    !isNullOrUndefined(this.props.model.result.username) &&
                    <TextField
                        id="result-user-name"
                        label="Username"
                        lineDirection="center"
                        value={this.props.model.result.username}
                        disabled={true}
                    /> 

                }
                    <TextField
                        id="result-name"
                        label="Name"
                        lineDirection="center"
                        value={this.props.model.result.submitted_name}
                        disabled={true}
                    /> 
                    <TextField
                        id="result-score"
                        label="Score"
                        lineDirection="center"
                        value={this.props.model.result.score}
                        disabled={true}
                    /> 
                    <TextField
                        id="result-time"
                        label="Submitted"
                        lineDirection="center"
                        value={resultDateString}
                        disabled={true}
                    />            
                    <a href={this.props.model.result.certificate_url}>
                    Download Certificate
                    </a>
                </DialogContainer>
            }
            
            </div>
            
        );
    }
}

export default ViewResultDialog;


// WEBPACK FOOTER //
// ./src/view/Admin/ResultsView/ResultsTableView/ViewResultDialog/ViewResultDialog.tsx